"use strict";

let alertService = function (ApplicationService, SchoolModelService) {

    var policy;
    var alerts;
    var family;
    var awardData;
    let school;

    /**
     * @typedef {Object} Alert
     * @property {string} completedText - Text to display for completed alert
     * @property {string} warningText - Text to display for incomplete alert
     * @property {string} name - name of alert
     * @property {string} text - Human-readable text to describe the alert
     * @property {boolean} disabled - set true to disable alert
     * @property {boolean} complete - set true to mark alert as complete
     * @property {boolean} fired - true to fire alert
     */
    /**
     * Create a new alert
     * @param {Alert} alert - Alert object
     */
    var setNewAlert = function (alert) {
        alerts[alert.name] = {
            completedText: alert.completedText != undefined ? getCompletedText(alert.completedText, alert.name) : "Complete",
            warningText: alert.warningText != undefined ? alert.warningText : "Reported",
            stateType: "warning",
            state: "warning",
            name: alert.name,
            text: alert.text,
            disabled: alert.disabled,
            complete: alert.complete,
            fired: alert.fired
        };
        alerts[alert.name].state = getAlertState(alert.name);
    };
    
    /**
     * Set alert to fired
     * @param {string} name - name of alert
     * @param {boolean} fired - true to fire alert
     */
    var setFired = function(name, fired)
    {
        alerts[name].fired = fired;
        alerts[name].state = getAlertState(name);
    };

    /**
     * Get alert state value based on its other values
     * @param {string} name - name of alert
     * @return {string} Alert state
     */
    var getAlertState = function(name)
    {
        if (alerts[name].disabled === '' || alerts[name].disabled === true)
            return "disabled";
         else if (alerts[name].fired == false)
            return "void";
         else if (alerts[name].complete == 0)
            return "success";
         else if (alerts[name].fired == true)
            return alerts[name].stateType; //warning or danger, disabled, or successful
    };

    /**
     * Get completion text to display upon completion of alert
     * @param {string} answerJson - json of answer object
     * @param {string} name - name of alert
     * @returns {string}
     */
    var getCompletedText = function(answerJson, name)
    {

        try
        {
            let json = JSON.parse(answerJson);
            let completedText;
            if (name === "businessIncomeReported") // Business income completion text
            {
                if (json.choice == "0")
                    completedText = "Used ISM <br>determined income";
                else if (json.choice == "1")
                    completedText = "Used Family <br>reported income";
                else if (json.choice == "2")
                    completedText = "Used net income <br>reported on taxes";
                else
                    completedText = "Used other amount <br>" + json.amount;
            }
            else if (name == "addedAllowance")
            {
                if (json.choice == "1")
                    completedText = "Not Added";
                else
                    completedText = "Complete";
            }
            else if (name == "assetsReported")
            {
                completedText = "Complete";
            }
            else if (name.indexOf("Threshold") !== -1) // Threshold exceeded completion text
            {
                if (json.choice == "0")
                    completedText = "Used School's Threshold";
                else if (json.choice == "1")
                    completedText = "Considered entire amount";
                else
                    completedText = "Considered $" + json.amount;
            }
            else if (name.indexOf("Reported") !== -1) // Added Allowances completion text
            {
                if (json.choice == "0")
                    completedText = "Not allowed";
                else if (json.choice == "1")
                    completedText = "Allowed entire amount";
                else
                    completedText = "Allowed $" + json.amount;
            }
            else
            {
                completedText = "Complete";
            }
            return completedText;

        }
        catch(e)
        {
            return answerJson;
        }

    };

    /**
     * Initialize alerts for a family
     * @param {Number} [fIndex] - index of family to initialize alerts
     */
    let initAlerts = function(fIndex) {
        policy = ApplicationService.getAwardData().policy[0];
        school = SchoolModelService.get()[0];
        if (typeof fIndex == "undefined")
            family = ApplicationService.getFamilyData();
        else
            family = ApplicationService.getAwardData().family[fIndex];

        awardData = family.awardData;

        alerts = {};


        // Added Allowance Alerts /////////

        setNewAlert({ name: 'otherTuitionReported', disabled: policy.Pref_3,
            complete: family.apWizard.case69, text: 'Other Tuition', completedText: family.apWizard.case69ans,
            warningText: "Reported", fired: false });

        setNewAlert({ name: 'collegeTuitionReported', disabled: policy.Pref_4,
            complete: family.apWizard.case70, text: 'College Tuition', completedText: family.apWizard.case70ans,
            warningText: "Reported", fired: false });

        setNewAlert({ name: 'medicalExpensesReported', disabled: policy.Pref_18,
            complete: family.apWizard.case82, text: 'Medical Expenses', completedText: family.apWizard.case82ans,
            warningText: "Reported", fired: false });

        setNewAlert({ name: 'childcareExpensesReported', disabled: policy.Pref_19,
            complete: family.apWizard.case83, text: 'Childcare Expenses', completedText: family.apWizard.case83ans,
            warningText: "Reported", fired: false });

        setNewAlert({ name: 'addedAllowance', disabled: policy.Pref_5,
            complete: family.apWizard.case79, text: 'Add Allowances', completedText: family.apWizard.case79ans,
            warningText: "Reported", fired: true});


        // Threshold Alerts //////////////

        setNewAlert({ name: 'housingThresholdExceeded', disabled: policy.Pref_11,
            complete: family.apWizard.case72, text: 'Housing Threshold', completedText: family.apWizard.case72ans,
            warningText: "Exceeded", fired: false });

        setNewAlert({ name: 'utilitiesThresholdExceeded', disabled: policy.Pref_12,
            complete: family.apWizard.case73, text: 'Utilities Threshold', completedText: family.apWizard.case73ans,
            warningText: "Exceeded", fired: false });

        setNewAlert({ name: 'autoInsuranceThresholdExceeded', disabled: policy.Pref_13,
            complete: family.apWizard.case74, text: 'Auto Insurance Threshold', completedText: family.apWizard.case74ans,
            warningText: "Exceeded", fired: false });

        setNewAlert({ name: 'lifeInsuranceThresholdExceeded', disabled: policy.Pref_16,
            complete: family.apWizard.case75, text: 'Life Insurance Threshold', completedText: family.apWizard.case75ans,
            warningText: "Exceeded", fired: false });

        setNewAlert({ name: 'charityThresholdExceeded', disabled: policy.Pref_15,
            complete: family.apWizard.case77, text: 'Charity Threshold', completedText: family.apWizard.case77ans,
            warningText: "Exceeded", fired: false });


        // Income Alerts ///////////////////

        setNewAlert({ name: 'incomeChange', disabled: false,
            complete: family.apWizard.case81, text: 'Adjust Income', completedText: "Complete",
            warningText: "Detected", fired: true });

        setNewAlert({ name: 'lowIncomeDetected', disabled: policy.Pref_2,
            complete: family.apWizard.case68, text: 'Low Income', completedText: "",
            warningText: "Detected", fired: false });

        setNewAlert({ name: 'businessIncomeReported', disabled: policy.Pref_9,
            complete: family.apWizard.case66, text: 'Business Income', completedText: family.apWizard.case66ans,
            warningText: "Reported", fired: false });


        // Miscellaneous Alerts ////////////

        //Tuition Alert
        setNewAlert({ name: 'tuitionAdjustment', disabled: policy.Pref_7,
            complete: family.apWizard.case78, text: 'Tuition Adjustment', completedText: family.apWizard.case78ans,
            warningText: 'Not Set', fired: false });

        //Two Family Alert
        setNewAlert({ name: 'twoFamiliesPresent', disabled: policy.Pref_6, 
            complete: family.apWizard.case80, text: "Two Families Present", completedText: "Complete",
            warningText: "Detected", fired: false
        });

        //Homemaker Alert
        setNewAlert({ name: 'homemakerDetected', disabled: policy.Pref_1,
            complete: family.apWizard.case67, text: 'Homemaker', completedText: '',
            warningText: "Detected", fired: false });

        //Percent Tuition Alert
        setNewAlert({ name: 'percentTuition', disabled: false,
            complete: family.apWizard.case85, text: 'Percent Tuition', completedText: "Complete",
            warningText: 'Detected', fired: false });

    };

    let businessIncomeAlert = function() { //66
        if ((family.edit_sums.Inc_Estate != 0 || family.edit_sums.Inc_Business != 0 || family.apWizard.case66ans) && policy.Pref_9 == 1) {
            setFired("businessIncomeReported", true);
        }
    };

    var homemakerAlert = function() //67
    {
        if (family.apWizard.case67ans)
        {
            alerts.homemakerDetected.state = 'success';
            if (JSON.parse(family.apWizard.case67ans).choice==0){
                alerts.homemakerDetected.completedText = "Not imputing income";
            }
            else {
                alerts.homemakerDetected.completedText = "Imputed $" + JSON.parse(family.apWizard.case67ans).amount;
            }
        }
        else if(policy.Pref_1 == 1)
        {
            var childrenAtHome = false;
            for (var i = 0 ; i < family.children.length; i++)
                if (family.children[i]['Chi_Present_Grade'] == 'N')
                    childrenAtHome = true;

            if (!childrenAtHome)
            {
                for (var i = 0 ; i < family.data.length; i++)
                {
                    if(family.data[i]['Fam_Occupation'] == "Homemaker")
                    {
                        setFired("homemakerDetected", true);
                        alerts.homemakerDetected.homemakerAnnualField = "Inc_Annual_" + (i + 1);
                    }
                }
            }
        }
    };

    var getHomemakerAnnualField = function() {
        var ret = "";
        for (var i = 0 ; i < family.data.length; i++)
        {
            if(family.data[i]['Fam_Occupation'] == "Homemaker")
            {
                ret = "Inc_Annual_" + (i + 1);
            }
        }
        return ret;
    };

    let lowIncome = function() { //68
        for (let i = 0; i < family.data.length; i++) {
            let alertFired = ((family.data[i]["Fam_Name_First"]
                && parseInt(family.edit_sums["Inc_Annual_" + (i + 1)]) <= parseInt(policy["Pref_2_amount"])
                && family.data[i].Fam_Occupation !== "Homemaker"));
            if (alertFired) {
                alerts.lowIncomeDetected.lowIncomeField = "Inc_Annual_" + (i + 1);
            }
            if (family.apWizard.case68ans) {
                alerts.lowIncomeDetected.state = "success";
            }
            else if (policy.Pref_2 == 1 && alertFired) {
                setFired("lowIncomeDetected", true);
            }
        }
    };

    var otherTuitionAlert = function () //69
    {
        if (policy.Pref_3 == 1 && getOtherTuition() > 0)
            setFired("otherTuitionReported", true);
    };

    var collegeTuitionAlert = function () //70
    {

        if (policy.Pref_4 == 1 && getColTuition() > 0)
            setFired("collegeTuitionReported", true);
    }

    //helper functions for calculating tuitions
    var getColTuition = function (fIndex = null)
    {
        var famcalc = fIndex != null ? ApplicationService.getAwardData().family[fIndex] : family;
        var colTuition = 0;
        for (var i = 0; i < famcalc.dependant.length; i++) {
            if (getField(famcalc.dependant[i], 'Dep_College') == '1' && getField(famcalc.dependant[i], 'Dep_Tuition_Amt') > 0)
                colTuition += parseInt(getField(famcalc.dependant[i], 'Dep_Tuition_Amt'));
        }
        return colTuition;
    };

    var getOtherTuition = function (fIndex = null)
    {
        var famcalc = fIndex != null ? ApplicationService.getAwardData().family[fIndex] : family;
        var otherTuition = 0;
        for (var i = 0; i < famcalc.dependant.length; i++) {
            if (getField(famcalc.dependant[i], 'Dep_College') != '1' && getField(famcalc.dependant[i], 'Dep_Tuition_Amt') > 0)
                otherTuition += parseInt(getField(famcalc.dependant[i], 'Dep_Tuition_Amt'));
        }
        for (var i = 0; i < famcalc.children.length; i++) {
            if (getField(famcalc.children[i], 'Chi_Tuition_Amt') > 0)
                otherTuition += parseInt(getField(famcalc.children[i], 'Chi_Tuition_Amt'));
        }
        return otherTuition;
    };

    var getField = function (item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field];
        else
            return item['x' + field];
    };

    var medicalAlert = function() //82
    {
        if (policy.Pref_18==1 && (family.edit_sums.Exp_Med_Val > policy.Pref_18_default || (family.edit_sums.Exp_Med_Val == policy.Pref_18_default && ApplicationService.getFamilyData().apWizard.case82ans)))
            setFired('medicalExpensesReported', true);
    };

    var childcareAlert = function() //83
    {
        if (policy.Pref_19==1 && (family.edit_sums.Exp_Childcare_Val > policy.Pref_19_default || (family.edit_sums.Exp_Childcare_Val == policy.Pref_19_default && ApplicationService.getFamilyData().apWizard.case83ans)))
            setFired('childcareExpensesReported', true);
    };

    var assetsAlert = function() //84
    {
        if (policy.Pref_20 ==1
            && ((family.edit_sums.Asset_Savings > policy.Pref_20_saving || (family.edit_sums.Asset_Savings == policy.Pref_20_saving && ApplicationService.getFamilyData().apWizard.case84ans)) 
            || (family.edit_sums.Asset_Checking > policy.Pref_20_checking || (family.edit_sums.Asset_Checking == policy.Pref_20_checking && ApplicationService.getFamilyData().apWizard.case84ans)) 
            || (family.edit_sums.Asset_Securities > policy.Pref_20_stock || (family.edit_sums.Asset_Securities == policy.Pref_20_stock && ApplicationService.getFamilyData().apWizard.case84ans))))
            setFired('assetsReported', true);
    };

    let housingAlert = function() //72
    {
        if ((awardData.housing.housing > awardData.housing.threshold || awardData.housing.housing == awardData.housing.threshold || family.apWizard.case72ans) && policy.Pref_11 == 1) {
            setFired('housingThresholdExceeded', true);
        }
    };

    var utiltiesAlert = function() //73
    {
        if (policy.Pref_12 == 1 && (awardData.utilities.utilities > awardData.utilities.threshold || (awardData.utilities.utilities == awardData.utilities.threshold && ApplicationService.getFamilyData().apWizard.case73ans)))
            setFired("utilitiesThresholdExceeded", true);
    };

    var autoInsuranceAlert = function() //74
    {
        if (policy.Pref_13 == 1)
        {
            if (family.edit_sums.Exp_Auto_Ins > family.thresholds.Thresh_Insurances_Cap_A || (family.edit_sums.Exp_Auto_Ins == family.thresholds.Thresh_Insurances_Cap_A && ApplicationService.getFamilyData().apWizard.case74ans))
                setFired("autoInsuranceThresholdExceeded", true);
            else {
                try
                {
                    JSON.parse(family.apWizard["case74ans"]);
                    alerts["autoInsuranceThresholdExceeded"].state = "success";
                } catch(e) {}
            }
        }
    };

    var lifeInsuranceAlert = function() //75
    {
        if (policy.Pref_16 == 1)
        {
            if (family.edit_sums.Exp_Life_Ins > family.thresholds.Thresh_Insurances_Cap_L || (family.edit_sums.Exp_Life_Ins == family.thresholds.Thresh_Insurances_Cap_L && ApplicationService.getFamilyData().apWizard.case75ans))
                setFired("lifeInsuranceThresholdExceeded", true);
            else {
                try
                {
                    JSON.parse(family.apWizard["case75ans"]);
                    alerts["lifeInsuranceThresholdExceeded"].state = "success";
                } catch(e) {}
            }
        }
    };

    var charityAlert = function() //77
    {
        if (policy.Pref_15 == 1 && (awardData.charity.charity > awardData.charity.threshold || (awardData.charity.charity == awardData.charity.threshold && ApplicationService.getFamilyData().apWizard.case77ans)))
            setFired("charityThresholdExceeded", true);
    };

    var tuitionAdjustment = function() //78
    {
        if (policy.Pref_7 == 1)
            setFired("tuitionAdjustment", true);
        else if (ApplicationService.getAwardData().applicants.length > 1 && (policy.Pref_7_Multi == 1 || policy.Pref_7_Other == 1))
            setFired("tuitionAdjustment", true);
    };

    var addedAllowance = function() //79
    {
        if (policy.Pref_5 == 1)
            setFired('addedAllowance', true);
    };

    var twoFamilies = function() //80
    {
        if (ApplicationService.isFamilyTwoSituation())
            setFired("twoFamiliesPresent", true);
    };

    let percentTuition = function() { //85
        if (school.Award_Pref_2 === 1 && ApplicationService.isFamilyTwoSituation()) {
            if (!ApplicationService.getFamilyData().apWizard.case85ans) {
                setFired("percentTuition", true);
            } else {
                alerts["percentTuition"].state = "success";
            }
        }
    };


    var calculateAlerts = function(fIndex)
    {
        if (typeof fIndex == "undefined")
            initAlerts();
        else
            initAlerts(fIndex);

        homemakerAlert();
        lowIncome();
        businessIncomeAlert();
        medicalAlert();
        childcareAlert();
        housingAlert();
        //assetsAlert();

        utiltiesAlert();
        collegeTuitionAlert();
        otherTuitionAlert();
        autoInsuranceAlert();
        lifeInsuranceAlert();
        charityAlert();
        tuitionAdjustment();
        addedAllowance();
        twoFamilies();
        percentTuition();
    };


    return {
        calculateAlerts: calculateAlerts,
        getCompletedText: getCompletedText,
        getColTuition: getColTuition,
        getOtherTuition: getOtherTuition,
        getAlerts: function()
        {
            return alerts;
        },
        getBothAlerts: function()
        {
            var bothAlerts = [];
            for (var i = 0; i < ApplicationService.getFamCount(); i++)
            {
                calculateAlerts(i);
                bothAlerts[i] = angular.copy(alerts);
            }
            return bothAlerts;

        },
        getHomemakerAnnualField: getHomemakerAnnualField
    }
};
angular.module("alertService", []).service("AlertService", alertService);
